<template>
    <dx-grid
        url="emails"
        :columns="columns"
        :title="title"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'email-body',
        }"
    ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Emails",
        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (row && (row.direction === "IN" || (value && value.trim() === "RECEIVED"))) {
                        return "mdi-inbox-arrow-down";
                    }
                    if (!value) return "";

                    switch (value.trim()) {
                        case "SENT":
                            return "mdi-check-circle";
                        case "FAILED":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (row && (row.direction === "IN" || (value && value.trim() === "RECEIVED"))) {
                        return "info";
                    }
                    if (!value) return "";

                    switch (value.trim()) {
                        case "SENT":
                            return "success";
                        case "FAILED":
                            return "#f35123";
                        default:
                            return "";
                    }
                },
            },
            {
                field: "hasAttachments",
                label: "Att.",
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: true,
                allowHeaderFiltering: true,
                allowHiding: true,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value) => {
                    return value ? "mdi-paperclip" : "";
                },
                iconColor: () => {
                    return "#5c6bc0";
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "hname",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
                visible: true,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Subject",
                field: "subject",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onRowClicked;
    },
    methods: {
        onRowClicked(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.accountID,
                },
                query: {
                    goToEmailsSection: true,
                },
            });
        },
    },
};
</script>
<style></style>
